;(function ($, window, document) {
    'use strict';
    var app = {
        timeInSecondsForLoandingAnimation: 2,
        initEnquire: function () {
            enquire.register('screen and (max-width:479px)', {
                match: function () {
                },
                unmatch: function () {
                }
            });
            enquire.register('screen and (min-width:480px) and (max-width:767px)', {
                match: function () {
                },
                unmatch: function () {
                }
            });
            enquire.register('screen and (min-width:768px) and (max-width:991px)', {
                match: function () {
                },
                unmatch: function () {
                }
            });
            enquire.register('screen and (min-width:992px) and (max-width:1199px)', {
                match: function () {
                },
                unmatch: function () {
                }
            });
            enquire.register('screen and (min-width:1200px)', {
                match: function () {
                },
                unmatch: function () {
                }
            });
        },
        initLazyLoad: function () {
            $("img.deffered,img[data-original]").lazyload({
              effect : "fadeIn",
              threshold : 200
            });
        },
        initPlaceholder: function () {
            $('input, textarea').placeholder();
        },
        initLangClick: function(){
            $('.m-language-selector__selected').click(function( event ){
                event.preventDefault();
                $('.m-language-selector__main').toggleClass('open');
            });
        },
        initMainNav: function () {
            var $menuItem = $('.m-nav__item');

            function showSubmenu($menuItem) {
                hideSubmenu($menuItem.siblings());
                $menuItem.find('.m-nav-submenu').css('display', 'block');
                setTimeout(function(){
                    $menuItem.find('.m-nav-submenu').addClass('m-nav-submenu--visible');
                    $menuItem.find('.m-nav__link').addClass('m-nav__link--active');
                    $menuItem.find('.m-nav__caret').addClass('m-nav__caret--active');

                    if ($menuItem.find('.m-nav-submenu').length) {
                        $menuItem.find('.m-nav__link').addClass('m-nav__link--active-submenu');
                    }
                }, 100);
            }

            function hideSubmenu($menuItem) {
                $menuItem.find('.m-nav-submenu').removeClass('m-nav-submenu--visible');
                $menuItem.find('.m-nav__link').removeClass('m-nav__link--active m-nav__link--active-submenu');
                $menuItem.find('.m-nav__caret').removeClass('m-nav__caret--active');


                setTimeout(function(){
                    $menuItem.find('.m-nav-submenu').css('display', 'none');
                }, 200);
            }

            // menu with click
            $menuItem.on('click touchend', function (event) {
                var $this = $(this);

                if ($this.find('.m-nav__caret').is(':visible')) {
                    if ($(event.target).hasClass('m-nav__caret') || $(event.target).closest('.m-nav__caret').length) {
                        event.preventDefault();

                        if ($this.find('.m-nav__link').hasClass('m-nav__link--active')) {
                            hideSubmenu($this);
                        } else {
                            showSubmenu($this);
                        }
                        return;
                    } else {
                        return;
                    }
                }

                if (!$this.find('.m-nav-submenu').length || $this.find('.m-nav__link').hasClass('m-nav__link--active')) {
                    return;
                }

                event.preventDefault();

                if ($this.find('.m-nav__link').hasClass('m-nav__link--active')) {
                    hideSubmenu($this);
                } else {
                    showSubmenu($this);
                }
            });

            // menu with hover
            $menuItem.hoverIntent({
                over: function () {
                    var $this = $(this);

                    if ($this.find('.m-nav__caret').is(':visible')) {
                        return;
                    }

                    $('.m-nav-submenu').css('display', 'none');
                    showSubmenu($this);
                },
                out: function () {
                    var $this = $(this);

                    if ($this.find('.m-nav__caret').is(':visible')) {
                        return;
                    }

                    hideSubmenu($this);
                },
                interval: 0,
                timeout: 100
            });
        },
        initActiveLinks: function () {
            var urlSplitted = window.location.pathname.substring(1).split('/');
            var urlToCheck = [];
            $.each(urlSplitted, function (index, value) {
                if (value.length) {
                    urlToCheck.push(value);
                    $('.m-nav__menu a').filter(function () {
                        var match = '^/' + urlToCheck.join('/') + '/$';
                        if ($(this).attr('href') !== undefined) {
                            return $(this).attr('href').match(new RegExp(match, "i"));
                        } else {
                            return false;
                        }
                    }).addClass('m-nav__link--current');

                    $('.m-footer__row a').filter(function () {
                        var match = '^/' + urlToCheck.join('/') + '/$';
                        if ($(this).attr('href') !== undefined) {
                            return $(this).attr('href').match(new RegExp(match, "i"));
                        } else {
                            return false;
                        }
                    }).addClass('m-nav__link--current');
                }
            });
        },
        initSlider: function () {
            $('.js-slider').each(function () {
                var $slider = $(this),
                    $sliderList = $slider.find('.js-slider__list'),
                    dataSlick = $sliderList.data('slick'),
                    params = {
                        prevArrow: $slider.find('.js-slider__prev'),
                        nextArrow: $slider.find('.js-slider__next'),
                        speed: 500,
                        draggable: false,
                        useCSS: true,
                        useTransform: true,
                        dots: true,
                        infinite: true,
                        dotsClass: 'm-dots'
                    };

                if (typeof dataSlick === 'object') {
                    params = $.extend(params, dataSlick);
                }

                $sliderList.slick(params);
            });
        },
        initSingleCarousel: function(obj){
            /**
             * Calculate slidesToScroll parameter for carousel.
             *
             * @param slidesToScroll
             * @param variableWidth
             * @returns {number}
             */
            function getSlidesToScroll(slidesToScroll, variableWidth) {
                slidesToScroll = slidesToScroll || 1;
                variableWidth = variableWidth || false;

                slidesToScroll = parseInt(slidesToScroll);

                var decreaseStep = 1;

                if (variableWidth) {
                    slidesToScroll = (slidesToScroll - decreaseStep < 1) ? 1 : parseInt(slidesToScroll - decreaseStep);
                }

                return slidesToScroll;
            }


            var $carousel = $(obj),
                $carouselList = $carousel.find('.js-carousel__list'),
                dataResponsive = $carouselList.data('responsive'),
                responsive = {
                    'desktop': 3,
                    'tablet-large': 3,
                    'tablet': 2,
                    'mobile': 1
                },
                dataSlick = $carouselList.data('slick'),
                params,
                variableWidth = false;

            if (typeof dataResponsive === 'object') {
                if (dataResponsive.hasOwnProperty('mobile')) {
                    responsive.mobile = dataResponsive.mobile;
                }

                if (dataResponsive.hasOwnProperty('tablet')) {
                    responsive.tablet = dataResponsive.tablet;
                }

                if (dataResponsive.hasOwnProperty('tableLarge')) {
                    responsive.tabletLarge = dataResponsive.tabletLarge;
                }

                if (dataResponsive.hasOwnProperty('desktop')) {
                    responsive.desktop = dataResponsive.desktop;
                }
            }

            if (typeof dataSlick === 'object') {
                if (dataSlick.hasOwnProperty('variableWidth') && dataSlick.variableWidth === true) {
                    variableWidth = true;
                }
            }

            params = {
                infinite: false,
                //arrows: false,
                prevArrow: $carousel.find('.js-carousel-prev'),
                nextArrow: $carousel.find('.js-carousel-next'),
                speed: 500,
                draggable: false,
                useCSS: true,
                useTransform: true,
                variableWidth: variableWidth,
                dots: true,
                dotsClass: 'm-dots',
                autoplay: false,
                slidesToShow: parseInt(responsive.desktop),
                slidesToScroll: getSlidesToScroll(responsive.desktop, variableWidth),
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: parseInt(responsive.tabletLarge),
                            slidesToScroll: getSlidesToScroll(responsive.tabletLarge, variableWidth)
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: parseInt(responsive.tablet),
                            slidesToScroll: getSlidesToScroll(responsive.tablet, variableWidth)
                        }
                    },
                    {
                        breakpoint: 766,
                        settings: {
                            slidesToShow: parseInt(responsive.mobile),
                            slidesToScroll: getSlidesToScroll(responsive.mobile, variableWidth)
                        }
                    }
                ]
            };

            if (typeof dataSlick === 'object') {
                params = $.extend(params, dataSlick);
            }

            return $carouselList.slick(params);
        },

        initCarousel: function (wrapper) {
            var $wrapper = wrapper || $('body');

            $('.js-carousel', $wrapper).each(function () {
                app.initSingleCarousel(this, wrapper);
            });
        },
        /**
         * Scroll to specific element or position with animation.
         *
         * @param $target
         * @param scrollTop
         * @param duration
         * @param checkHeader
         */
        scrollTo: function ($target, scrollTop, duration, checkHeader) {
            if (!scrollTop && !$target.length) {
                return;
            }

            scrollTop = scrollTop || $target.eq(0).offset().top;
            duration = duration || 'normal';

            if (checkHeader) {
                var header = $('#header');

                if (header && scrollTop > header) {
                    scrollTop = parseInt(scrollTop) - parseInt(header);
                }
            }

            $('html, body').animate({
                scrollTop: scrollTop
            }, duration);
        },
        initScrollTo: function () {
            $('[data-scroll-to]').on('click', function (e) {
                console.log(e);
                var $this = $(this),
                    $target = $($this.attr('data-scroll-to')),
                    scrollTop = ($target.attr('id') === 'top') ? '0' : null,
                    delay = parseInt($this.attr('data-delay'));

                setTimeout(function () {
                    app.scrollTo($target, scrollTop, null, true);
                }, (isNaN(delay)) ? 0 : delay);

                e.preventDefault();
            });
        },
        initSelectPicker: function () {
            var $select = $('select.form-control');

            function checkPlaceholder($selectElement) {
                var $select2Container = $selectElement.next('.select2-container');

                if ($selectElement.val()) {
                    $select2Container.addClass('select2-container--has-value');
                } else {
                    $select2Container.removeClass('select2-container--has-value');
                }
            }

            function refreshSlider($selectElement) {
                var $section = $selectElement.closest('.m-section');

                var $sliders = $section.find('.m-carousel');
                if ($sliders.length) {

                    $.each($sliders, function(index, slider) {
                        $(slider).find('.js-carousel__list').slick('slickUnfilter');
                        if (parseInt($selectElement.val()) !== -1) {
                            $(slider).find('.js-carousel__list').slick('slickFilter', "li[data-category='"+$selectElement.val()+"']");
                        }
                    });
                }
            }

            // Init Select2
            $select
                .select2({
                    minimumResultsForSearch: Infinity,
                    theme: "form-control",
                    width: $select.attr('data-width') || '100%'
                })
                .on("change", function () {
                    refreshSlider($(this));
                    checkPlaceholder($(this));
                });

            $select.each(function () {
                var $this = $(this),
                    icon = $this.attr('data-icon'),
                    placeholder = $this.attr('data-custom-placeholder'),
                    $select2Container = $this.next('.select2-container'),
                    $selectionRendered = $select2Container.find('.select2-selection__rendered');

                if ($selectionRendered.length) {
                    // add icon
                    if (typeof icon !== 'undefined') {
                        $selectionRendered.before('<span class="select2-selection__custom-placeholder">' +
                            '<span class="select2-selection__icon">' +
                            icon +
                            '</span>' +
                            '</span>');
                    }

                    // add placeholder for multiple select
                    if (typeof placeholder !== 'undefined' && typeof $this.attr('multiple') !== 'undefined') {
                        $select2Container.find('.select2-selection__custom-placeholder')
                            .append(placeholder);

                        checkPlaceholder($this);
                    }
                }
            });
        },
        initMatchHeight: function () {
            $('.js-match-height').matchHeight();

            for (var i = 1; i < 10; i++) {
                $('.js-match-height-' + i).matchHeight();
            }

            $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                // Update matchHeight if higher tab has been shown
                var $newTab = e.target ? $(e.target.getAttribute('href')) : null,
                    $previousTab = e.relatedTarget ? $(e.relatedTarget.getAttribute('href')) : null;

                if ($newTab && $previousTab && $newTab.outerHeight() > $previousTab.outerHeight()) {
                    $.fn.matchHeight._update();
                }
            });

            $('.collapse').on('shown.bs.collapse', function () {
                $.fn.matchHeight._maintainScroll = true;
                $.fn.matchHeight._update();
            });
        },

        initShowContentButton: function () {
            $('[data-toggle="collapse"]').on('click', function () {
                var options = $(this).data('options');

                if (typeof options === 'object' && options.hasOwnProperty('hideClosest')) {
                    //noinspection JSUnresolvedVariable
                    $(this).closest(options.hideClosest).hide();
                }

                if (typeof options === 'object' && options.hasOwnProperty('hideElement')) {
                    //noinspection JSUnresolvedVariable
                    $('body').find(options.hideElement).toggle();
                }
            });
        },
        initGalleryModal: function() {
            $(document).delegate('*[data-toggle="lightbox"]', 'click', function(event) {
                event.preventDefault();
                $(this).ekkoLightbox({
                    left_arrow_class: '.fa .fa-angle-left .glyphicon .glyphicon-chevron-left',
                    right_arrow_class: '.fa .fa-angle-right .glyphicon .glyphicon-chevron-right'
                });
            });
        },



        initToggleMenu: function() {
            $('.header-menu__toggle').on('click', function(e) {
                e.preventDefault();
                $(this).find('.burger-icon').toggleClass('open');
                console.log($(this).find('.burger-icon'));
                $('body').toggleClass('menu-open');
                $('.header-brand').stop(true).fadeToggle(300);
                $('.m-language-selector').stop(true).fadeToggle(300);
                $('.menu-overlay').toggleClass('fade-in');
                $('.m-nav').stop(true).fadeToggle(300);
            });
        },

        updateLikes: function(){
          var storage = window.localStorage,
              likes = storage.getItem('likes');

          if (likes === null) {
            likes = [];
          } else {
            likes = JSON.parse(likes);
          }

          app.updateFavorites(likes);


          $('.models__like').each(function(){
              var root = $(this),
                  id = root.data('id');

              if (id && ~likes.indexOf(id)) {
                  root.removeClass('no');
                  root.addClass('yes');
              }
          }).off('click.toggle.like').on('click.toggle.like', function(){
            var root = $(this),
              id = root.data('id');
            var state = $(this).hasClass('yes');
            if (state === false) {
              likes.push(id);
              root.addClass('yes').removeClass('no');
            } else if(state === true && ~likes.indexOf(id)) {
              likes.splice(likes.indexOf(id),1);
              root.addClass('no').removeClass('yes');
            }

            storage.setItem('likes', JSON.stringify(likes));
            app.updateFavorites(likes);
          });
        },
        initLikeIcon: function() {
            app.updateLikes();
        },
        updateFavorites: function(likes){
            var bar = $('.favorites__number');

            bar.find('.value').text(likes.length);
        },
        goTopOnclick: function () {
            $('.go-to-top').on('click', function(){
                $("html,body").animate({scrollTop: 0}, 700);
            });
        },
        initScrollAnimation: function() {
            var $animatedElement = $('.animated');
            var $documentEl = $(document);

            $animatedElement.each(function() {
                if (( $documentEl.scrollTop() + $(window).height() > $(this).offset().top + $(this).height() )) {
                    $(this).removeClass('animated');
                }
            });

          setTimeout(function() {
            $animatedElement.each(function() {
              if ((
                      $documentEl.scrollTop() + $(window).height() >
                      $(this).offset().top + $(this).height()
                  )) {
                $(this).removeClass('animated');
              }
            });
          }, (
              app.timeInSecondsForLoandingAnimation * 150
          ));
        },
        // LightBox - change (image) and (of) words from English to German
        changeLightboxImagesWord: function () {
            window.lightbox.option({
                'albumLabel': '%1 / %2',
            });
        },
        initForm: function() {
            var $inputElement = $('form :input');
            $inputElement.on('blur changeDate',function() {
                if( $(this).val() && !$(this).hasClass('form-control--special') && !$(this).hasClass('form-control--special-two') ) {
                    $(this).addClass('form-control--has-value');
                } else {
                    $(this).removeClass('form-control--has-value');
                }
            }).trigger('blur');

            Parsley.setLocale($('html').attr('lang')); // jshint ignore:line

            var validateFileUploads = function(){
                var fields = $('form').find('input[type=file]'), files = [], maxFileSize = 10 * 1024 * 1024, totalSize = 0, notEmptyFields = $();


                fields.each(function(key, field){

                    var file = field.files && field.files[0] ? field.files[0] : false;

                    if (file) {
                        files.push(file);
                        notEmptyFields = notEmptyFields.add(field);
                    }
                });



                $.each(files, function(key, file){
                    totalSize += file.size;
                });


                if (totalSize > maxFileSize) {
                    this.validationResult = false;
                    notEmptyFields.parents('.file-select').addClass('parsley-error');
                    $('#wrong-filesize').addClass('filled');
                } else {
                    fields.parents('.file-select').removeClass('parsley-error');
                    $('#wrong-filesize').removeClass('filled');
                }

            };

            var checkCaptcha = function(){
                var holder = $('#captcha-holder'),
                    field = holder.find('#g-recaptcha-response');

                if (!field.length || field.val() === '') {
                  this.validationResult = false;
                  holder.next().addClass('filled');
                } else {
                  holder.next().removeClass('filled');
                }

            };

            if($('form').length > 0) {
              $('form').parsley().on('form:validate', function(){
                validateFileUploads.apply(this, []);
                checkCaptcha.apply(this, []);
              }).on('field:validate', function(){
                if (this.element.type === 'file') {
                  validateFileUploads.apply(this, []);
                }
              });
            }




            $('.file-upload').each(function(){
                var root = $(this),
                    uploadField = root.find('input[type="file"]');

                uploadField.on('change', function(){
                    var file = this.files && this.files[0] ? this.files[0] : false;
                    root.find('.file-select-name').val(file.name);
                });
            });


        },
        initAnimation: function() {
            setTimeout(function() {
                app.initScrollAnimation();
                $('body').removeClass('body__animated');
            }, (
                app.timeInSecondsForLoandingAnimation * 1000
            ) + 1000);
        },
        tet: function() {
                $("a:not('.models__image--with-icon, .lb-prev, .lb-next')" ).click(function(e) {
                    var anchor = $(this), addressValue = anchor.attr("href");

                    if( /\/.*/.test(addressValue) && !anchor.attr('target')) {
                        e.preventDefault();
                        $('body').addClass('menu-open');
                        $('body > .loading').removeClass('loading--hide');

                        setTimeout(function() {
                            //As an HTTP redirect (back button will not work )
                            window.location.replace(addressValue);
                            //like if you click on a link (it will be saved in the session history, 
                            //so the back button will work as expected)
                            window.location.href = addressValue;
                        }, (
                            app.timeInSecondsForLoandingAnimation * 200
                        ));
                    }
            }); 
        },
        initMap: function(){

            $('.m-map').each(function(){
                var map = $(this),
                    data = map.data();

                if (!data.key) {
                    console.log('Please add key for google map api');
                    return false;
                }

                var url = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAfIU61zIUCer8dYMywXUruZg6t_gyCTX4&callback=initMap';

                window.initMap = function(){
                  var origin = {lat: parseFloat(data.lat), lng: parseFloat(data.lng)};
                  var m = new google.maps.Map(map[0], { // jshint ignore:line
                    zoom: parseInt(data.zoom) || 5,
                    center: origin
                  });

                  var marker = new google.maps.Marker({ // jshint ignore:line
                    position: origin,
                    map: m,
                    icon: {
                        url: data.marker,
                        size: new google.maps.Size(154, 143), // jshint ignore:line
                        origin: new google.maps.Point(0,0) // jshint ignore:line
                    }
                  });
                };

                $('body').append('<script src="'+url+'" async defer/>');
            });
        },
        changeMapStyle: function() {
          if ($('#map').length) {
            var $mapContainer = $('#map'),
                myLatLng = null,
                mapOptions = {
                  zoom: 14,
                  mapTypeId: window.google.maps.MapTypeId.roadmap, // jshint ignore:line
                  scrollwheel: false,
                  mapTypeControl: false,
                  draggable: false,
                  scaleControl: false,
                  navigationControl: false,
                  zoomControl: true,
                  styles: [
                    {
                      'featureType': 'all',
                      'elementType': 'geometry.fill',
                      'stylers': [
                        {
                          'weight': '2.00',
                        },
                      ],
                    },
                    {
                      'featureType': 'all',
                      'elementType': 'geometry.stroke',
                      'stylers': [
                        {
                          'color': '#9c9c9c',
                        },
                      ],
                    },
                    {
                      'featureType': 'all',
                      'elementType': 'labels.text',
                      'stylers': [
                        {
                          'visibility': 'on',
                        },
                      ],
                    },
                    {
                      'featureType': 'administrative.country',
                      'elementType': 'geometry',
                      'stylers': [
                        {
                          'visibility': 'simplified',
                        },
                        {
                          'saturation': '47',
                        },
                        {
                          'color': '#db1a1a',
                        },
                      ],
                    },
                    {
                      'featureType': 'landscape',
                      'elementType': 'all',
                      'stylers': [
                        {
                          'color': '#f2f2f2',
                        },
                      ],
                    },
                    {
                      'featureType': 'landscape',
                      'elementType': 'geometry.fill',
                      'stylers': [
                        {
                          'color': '#ffffff',
                        },
                      ],
                    },
                    {
                      'featureType': 'landscape.man_made',
                      'elementType': 'geometry.fill',
                      'stylers': [
                        {
                          'color': '#eeeeee',
                        },
                      ],
                    },
                    {
                      'featureType': 'poi',
                      'elementType': 'all',
                      'stylers': [
                        {
                          'visibility': 'off',
                        },
                      ],
                    },
                    {
                      'featureType': 'road',
                      'elementType': 'all',
                      'stylers': [
                        {
                          'saturation': -100,
                        },
                        {
                          'lightness': 45,
                        },
                      ],
                    },
                    {
                      'featureType': 'road',
                      'elementType': 'geometry.fill',
                      'stylers': [
                        {
                          'color': '#eeeeee',
                        },
                      ],
                    },
                    {
                      'featureType': 'road',
                      'elementType': 'labels.text.fill',
                      'stylers': [
                        {
                          'color': '#7b7b7b',
                        },
                      ],
                    },
                    {
                      'featureType': 'road',
                      'elementType': 'labels.text.stroke',
                      'stylers': [
                        {
                          'color': '#ffffff',
                        },
                      ],
                    },
                    {
                      'featureType': 'road.highway',
                      'elementType': 'all',
                      'stylers': [
                        {
                          'visibility': 'simplified',
                        },
                      ],
                    },
                    {
                      'featureType': 'road.arterial',
                      'elementType': 'labels.icon',
                      'stylers': [
                        {
                          'visibility': 'off',
                        },
                      ],
                    },
                    {
                      'featureType': 'transit',
                      'elementType': 'all',
                      'stylers': [
                        {
                          'visibility': 'off',
                        },
                      ],
                    },
                    {
                      'featureType': 'water',
                      'elementType': 'all',
                      'stylers': [
                        {
                          'color': '#46bcec',
                        },
                        {
                          'visibility': 'on',
                        },
                      ],
                    },
                    {
                      'featureType': 'water',
                      'elementType': 'geometry.fill',
                      'stylers': [
                        {
                          'color': '#c8d7d4',
                        },
                      ],
                    },
                    {
                      'featureType': 'water',
                      'elementType': 'labels.text.fill',
                      'stylers': [
                        {
                          'color': '#009190',
                        },
                      ],
                    },
                    {
                      'featureType': 'water',
                      'elementType': 'labels.text.stroke',
                      'stylers': [
                        {
                          'color': '#ffffff',
                        },
                      ],
                    },
                  ],
                };

            if ($mapContainer.data('lat') && $mapContainer.data('lng')) {
              myLatLng = new google.maps.LatLng($mapContainer.data('lat'), $mapContainer.data('lng')); // jshint ignore:line
              mapOptions.center = myLatLng;
            }
            var map = new google.maps.Map(document.getElementById('map'), mapOptions); // jshint ignore:line
            var image = {
              url: $mapContainer.data('marker'),
              labelOrigin: new window.google.maps.Point(85, 20),
            };
            if (myLatLng) {
              var marker = new google.maps.Marker({ // jshint ignore:line
                position: myLatLng,
                map: map,
                icon: image,
              });
            }
          }
        },
        initSelect: function(){
            $("section div a").filter(function() {
                return this.href === document.location.href;
            }).addClass("button--active");
        },
        initFadeInLazy: function() {
            $('.arts').fadeIn(1000);
        },
        initFadeAll: function() {
            /*Everytime the window is scrolled.. */
            $(window).scroll(function(){

                /* Check the location of each desired element */
                $('.arts-fade').each(function(i) { // jshint ignore:line

                    var bottom_of_object = $(this).position().top + $(this).outerHeight();
                    var bottom_of_window = $(window).scrollTop() + $(window).height();

                /* If the object is completely visible in the window, fade it in */
                if(bottom_of_window > bottom_of_object) {

                    $(this).animate({'opacity':'1'},1500);
                }
                });
            });
        },
        initCookie: function() {
            // If the 'hide cookie is not set we show the message
            if (!readCookie('hide')) {
                $('.m-cookie').show();
            }

            // Add the event that closes the popup and sets the cookie that tells us to
            // not show it again until one day has passed.
            $('#close').click(function() {
                $('.m-cookie').fadeToggle(700);
                createCookie('hide', true, 7)
                return false;
            });

          

            // ---
            // And some generic cookie logic
            // ---
            function createCookie(name,value,days) {
            if (days) {
                var date = new Date();
                date.setTime(date.getTime()+(days*24*60*60*1000));
                var expires = "; expires="+date.toGMTString();
            }
            else var expires = "";
            document.cookie = name+"="+value+expires+"; path=/";
            }

            function readCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for(var i=0;i < ca.length;i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1,c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
            }
            return null;
            }

            function eraseCookie(name) {
            createCookie(name,"",-1);
            }

        },
        initCookieFadeOut: function() {
          
          
                
            
        }
    };

    $(document).ready(function () {
        $('.not-initialized').removeClass('not-initialized');
        app.initLazyLoad();
        app.initLikeIcon();
        app.initEnquire();
        app.initPlaceholder();
        app.initLangClick();
        app.initMainNav();
        app.initActiveLinks();
        app.initSlider();
        app.initCarousel();
        app.initScrollTo();
        app.initSelectPicker();
        app.initShowContentButton();
        app.initGalleryModal();
        app.initToggleMenu();
        app.goTopOnclick();
        app.changeLightboxImagesWord();
        app.initForm();
        app.initAnimation();
        app.initMap();
        app.tet();
        app.changeMapStyle();
        app.initSelect();
        app.initFadeInLazy();
        app.initFadeAll();
        app.initMatchHeight();
        app.initCookie();
        app.initCookieFadeOut();
    });

    $(window).on('load', function () {
    // Loading //

   
    $(document).ready(function () {
    $("html,body").animate({scrollTop: 0}, "slow");   
        $('.loading__block').fadeOut( 2000, function () {  //fade out logo
            $('.loading').fadeOut(500, function () {  //fade out for backgorund
             $(this).remove();  // remove load from html    
             }
            )}
        )}
    );
   

    });

    $(window).resize(function () {

    });

    $(window).scroll(function () {
        app.initScrollAnimation();        
        
    });
})(jQuery, window, document);



